import { useContext } from "react";
import { ExperimentContext } from "../context/experiment-context";
import {
  useFeatureIsOn as useFeatureIsOnGb,
  useFeatureValue as useFeatureValueGb,
} from "@growthbook/growthbook-react";

export function useExperiment<T>() {
  const client = useContext(ExperimentContext);

  if (!client) {
    throw new Error("useExperiment must be used within an ExperimentProvider");
  }

  function useExperimentIsOn(id: string) {
    return useFeatureIsOnGb(id);
  }

  function useExperimentValue(id: string, defaultValue?: string | boolean) {
    return useFeatureValueGb(id, defaultValue);
  }

  return {
    useExperimentIsOn,
    useExperimentValue,
    client,
  };
}
